import React from 'react'
import { connect } from 'react-redux'
import { Flags } from 'react-feature-flags'
import PropTypes from 'prop-types'
import Tooltip from 'rc-tooltip'
import SelectionOrganizer from './SelectionOrganizer'
import Search from './Search'
import { setMode } from '../../actions/mapSettings'
import { showReport } from '../../actions/report'
import IconClickTarget from '../../../img/icon-click-target.svg'
import IconSelectBox from '../../../img/icon-select-box.svg'
import IconSelectShape from '../../../img/icon-select-shape.svg'
import { setDialog as setDialogConnect } from '../../actions/navigation'

const Select = ({ mode, items, setMode, onReport, setDialog, collapseContent }) => {
    const canSubmit = items.some(item => item.type === 'parcel')
    return (
        <div className="select-function">
            <div className="top">
                <div className="content-section">
                    <h5 className="title is-5">Select Parcels</h5>
                    <p>
                        Select parcels by choosing them from the map, searching for APN number or address, or selecting
                        all parcels within an area.
                    </p>

                    <p>
                        <a onClick={() => setDialog('error')}>Click here to report any errors or issues.</a>
                    </p>

                    <h5 className="title is-6 search-apn">Search by APN or Address</h5>
                    <Search collapseContent={collapseContent} />

                    <h5 className="title is-6">Select from Map</h5>
                    <div className="button-group">
                        <button
                            className={`button ${mode === 'single' ? 'is-primary' : ''}`}
                            onClick={() => setMode('single')}
                        >
                            <IconClickTarget style={{ width: '22px' }} />
                            &nbsp;Single
                        </button>
                        <button
                            className={`button ${mode === 'box' ? 'is-primary' : ''}`}
                            onClick={() => setMode('box')}
                        >
                            <IconSelectBox style={{ width: '22px' }} />
                            &nbsp;Box
                        </button>
                        <button
                            className={`button ${mode === 'shape' ? 'is-primary' : ''}`}
                            onClick={() => setMode('shape')}
                        >
                            <IconSelectShape style={{ width: '22px' }} />
                            &nbsp;Shape
                        </button>
                    </div>
                    <p className={`unselect-instructions ${mode !== 'single' ? '' : 'hidden'}`}>
                        Hold the alt/option key to unselect parcels.
                    </p>
                </div>
                <div className="content-section alt">
                    <h5 className="title is-5">Create projects</h5>
                    <p>
                        Optionally group parcels into a project by selecting two or more parcels and clicking the add
                        project button.
                    </p>
                    <SelectionOrganizer />
                </div>
            </div>
            <div className="content-section bottom">
                <h5 className="title is-5">Create report</h5>
                <p>
                    Click "Create Report" for a summary of which streamlining provisions your parcels and projects may
                    qualify for.
                </p>
                <div>&nbsp;</div>
                <Tooltip
                    overlayClassName="tooltip"
                    trigger={items.length < 1 ? ['hover'] : []}
                    placement="top"
                    overlay={<span>Select one or more parcels to analyze</span>}
                >
                    <button
                        className={`button is-primary is-fullwidth ${!canSubmit ? 'is-disabled' : ''}`}
                        onClick={() => canSubmit && onReport()}
                    >
                        Create Report
                    </button>
                </Tooltip>
            </div>
        </div>
    )
}

Select.propTypes = {
    // parent
    collapseContent: PropTypes.func.isRequired,
    // redux state
    mode: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    // redux actions
    setMode: PropTypes.func.isRequired,
    onReport: PropTypes.func.isRequired,
    setDialog: PropTypes.func.isRequired
}

export default connect(
    ({ mapSettings: { mode }, parcels: { items } }) => ({ mode, items }),
    dispatch => ({
        setMode: mode => dispatch(setMode(mode)),
        onReport: () => dispatch(showReport(true)),
        setDialog: modalName => dispatch(setDialogConnect(modalName))
    })
)(Select)

export { Select as _Select }
